<template>
    <table class="banner data">
        <tr>
            <td colspan="2">
                <strong>{{ banner.title }}</strong>
                &nbsp;
                <span style="font-size: 0.8em"> ({{ $t('called_n_times', { count: banner.count || 0 }) }}) </span>
            </td>
        </tr>
        <tr>
            <td>{{ $t('page') }}</td>
            <td>
                <a :href="banner.link" target="_blank">{{ banner.link }}</a>
            </td>
        </tr>
        <tr>
            <td valign="top">{{ $t('orte') }}:</td>
            <td>{{ getBannerLocations(banner).join(', ') }}</td>
        </tr>
        <tr>
            <td>{{ $t('publiziert_ab') }}</td>
            <td>
                <strong>
                    {{ banner.publish_from.isValid() ? banner.publish_from.formatIf('dd, DD.MM.YYYY') : '-' }}
                </strong>
                bis:
                <strong>
                    {{ banner.publish_to.isValid() ? banner.publish_to.formatIf('dd, DD.MM.YYYY') : '-' }}
                </strong>
                | {{ $t('created') }}:
                {{ banner.created.isValid() ? banner.created.formatIf('dd, DD.MM.YYYY') : '-' }}
            </td>
        </tr>
    </table>
</template>

<script>
import { Banner, LOCATION as BannerLocation } from '@/models/Banner';

/**
 * The description field of the banner list view
 */
export default {
    name: 'BannerListDescription',
    props: {
        banner: {
            type: Banner,
            required: true,
        },
    },

    methods: {
        getBannerLocations(banner) {
            let assignedLocations = banner.location_idents || [];
            if (assignedLocations.length < 1) {
                return ['-'];
            }
            return assignedLocations
                .map((locIdent) => {
                    let entry = BannerLocation[locIdent];
                    if (entry) {
                        return this.$t(entry.title_key);
                    } else {
                        return null;
                    }
                })
                .filter(Boolean);
        },
    },
};
</script>
